import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL;

export default function GameStats() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/prod/game_scores`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'stats' }),
    })
      .then(r => r.json())
      .then(d => { const b = typeof d.body === 'string' ? JSON.parse(d.body) : d.body || d; setData(b); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 20, color: '#9ca3af' }}>Cargando...</div>;
  if (!data) return <div style={{ padding: 20, color: '#9ca3af' }}>Sin datos</div>;

  const s = data.stats || {};

  return (
    <div style={{ marginTop: 20 }}>
      <h2>🎮 Estadísticas del Juego</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
        <div style={{ background: '#e8f0fe', borderRadius: 14, padding: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: '#1b2938' }}>{s.jugadores || 0}</div>
          <div style={{ fontSize: 12, color: '#4b5563' }}>Jugadores</div>
        </div>
        <div style={{ background: '#dcfce7', borderRadius: 14, padding: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: '#166534' }}>{s.total_partidas || 0}</div>
          <div style={{ fontSize: 12, color: '#4b5563' }}>Partidas</div>
        </div>
        <div style={{ background: '#fef3c7', borderRadius: 14, padding: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: '#92400e' }}>🍌 {s.max_score || 0}</div>
          <div style={{ fontSize: 12, color: '#4b5563' }}>Record</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
        <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#1b2938', marginBottom: 8 }}>Mundos</div>
          {(data.mundos || []).map(m => (
            <div key={m.mundo} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '4px 0' }}>
              <span>{m.mundo}</span><span style={{ fontWeight: 700 }}>{m.partidas}</span>
            </div>
          ))}
        </div>
        <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#1b2938', marginBottom: 8 }}>Personajes</div>
          {(data.personajes || []).map(p => (
            <div key={p.personaje} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '4px 0' }}>
              <span>{p.personaje}</span><span style={{ fontWeight: 700 }}>{p.partidas}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: '1px solid #e2e8f0' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#1b2938', marginBottom: 8 }}>Partidas recientes</div>
        {(data.recientes || []).map((r, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '6px 0', borderBottom: '1px solid #f3f4f6' }}>
            <span>📞 {r.msisdn || 'anon'}</span>
            <span>{r.personaje} · {r.mundo}</span>
            <span style={{ fontWeight: 700 }}>🍌 {r.score}</span>
          </div>
        ))}
      </div>

      <div style={{ height: 80 }} />
    </div>
  );
}
